import { BCMSRecord, BCMSRecordProperty } from "@bcm-dev/bcms-vite";
import { Account, FedWire, Payee } from "model";
/**
* @class OutgoingFedWire
* @classdesc Class definition for record type from model
* @param {OBJECT} record - record from model to init class
* @extends BCMSRecord
* @example const record = model.outgoingFedWires[0];
* const wire = new OutgoingFedWire(record);
* @property {NUMBER} _mapID - used to map wire information with outgoing wire data
*/
   
export default class OutgoingFedWire extends BCMSRecord { 
    _mapID
    _referenceNumber
    _payee
    _fundingAccount

    constructor(record) {   
      super(Object.assign(record, FedWire.initByID(record.mapID).record));
    }    

    /** 
    * @function initAll   
    * @static
    * @property {VOID} - No parameters
    * @description Returns all accounts with branding option "Show Business Accounts" 
    * (action script name: show_business_accounts_abi22) applied.
    * @example const accounts = CheckingAccount.initAll();
    * @memberof CheckingAccount 
    */
    static initAll() {
      const wires = this._GlobalController.state[this._RecordType]

      return wires.reduce((acc, record) => {
        if(record instanceof Object) {
          acc.push(FedWire.initByType(record.mapID))
        }

        return acc;
      }, []);
    }
  }   
  OutgoingFedWire.define({
    "recordType":"outgoingFedWires",
    "recordIDProp":"mapID",
    "className" : "OutgoingFedWire",
    "recordProperties": [
    /** 
    * @name mapID
    * @instance
    * @property get {NUMBER} - gets the mapID of the OutgoingFedWire
    * @property set {NUMBER} - sets the mapID of the OutgoingFedWire
    * @memberof OutgoingFedWire 
    */
    BCMSRecordProperty.mapToNumber("mapID", "_mapID"),

    /** 
    * @name referenceNumber
    * @instance
    * @property get {STRING} - gets the referenceNumber of the OutgoingFedWire
    * @property set {STRING} - sets the referenceNumber of the OutgoingFedWire
    * @memberof OutgoingFedWire 
    */
    BCMSRecordProperty.mapToString("referenceNumber", "_referenceNumber"),

    /** 
    * @name payee
    * @instance
    * @property get {STRING} - gets the payee of the OutgoingFedWire
    * @property set {STRING} - sets the payee of the OutgoingFedWire
    * @memberof OutgoingFedWire 
    */
    BCMSRecordProperty.mapToClass("payee", "_payee", () => Payee),

    /** 
    * @name fundingAccount
    * @instance
    * @property get {OBJECT} - gets the fundingAccount of the OutgoingFedWire
    * @property set {OBJECT} - sets the fundingAccount of the OutgoingFedWire
    * @memberof OutgoingFedWire 
    */
    BCMSRecordProperty.mapToClass("fundingAccount", "_fundingAccount", () => Account),

  ].concat(FedWire._RecordProperties)
})




